import {ErrorMessage, Field, Form, Formik} from "formik";
import React, {useState} from "react";
import styles from "../../styles/list_styles.module.scss";
import Button from "../../components/Button/Button";

import {ReactComponent as Download} from "../../assets/icons/download.svg";
import {ReactComponent as Pencil} from "../../assets/icons/pencil.svg";
import {ReactComponent as Trash} from "../../assets/icons/trash.svg";

import {BarLoader} from "react-spinners";
import {useNavigate} from "react-router-dom";
import {deleteCategory, getCategories, serializeArray} from "../../services/services";
import Pagination from "../../components/Pagination/Pagination";
import ModalConfirm from "../../components/ModalConfirm/ModalConfirm";
import {useMutation, useQuery} from "react-query";
import {toast} from "react-toastify";
import {queryClient} from "../../services/queryClient";
import {getToken} from "../../services/auth";
import {ICategoriesResponse, IGetCategories} from "../../ts/interfaces/Category/interface";

const Categories: React.FC = () => {
    document.title = 'Admin - Categorias';

    const [filter, setFilter] = useState<IGetCategories>({
        id: null,
        name: null,
        page: 1,
        limit: 50,
    });

    const [open, setOpen] = useState(false);
    const [id, setId] = useState<number | null>(null);

    const navigate = useNavigate();

    const {data, isLoading} = useQuery<ICategoriesResponse>(
        ["categories", filter],
        () => getCategories(filter),
        {
            staleTime: Infinity,
        }
    );

    const handleDownloadCSV = () => {
        let link = document.getElementById("download_csv");
        link?.click();
    };

    const mutateDeleteCategory = useMutation(
        () => {
            return deleteCategory(id as number);
        },
        {
            onSettled: (data) => {
                if (data?.data?.success) {
                    queryClient.invalidateQueries(["categories", filter]);
                    toast.success('Deletado com sucesso');
                } else {
                    toast.error("Erro ao deletar categoria. " + data?.data?.msg);
                }
                setOpen(false);
            },
            onError: () => {
                toast.error("Erro ao deletar categoria.");
            },
        }
    );


    return (
        <div className={styles.container}>
            <h1>Categorias</h1>

            <Formik
                initialValues={{
                    id: "",
                    name: "",
                }}
                onSubmit={(values) => {
                    setFilter({
                        ...filter,
                        id: values.id && values.id !== '' ? parseInt(values.id) : null,
                        name: values.name,
                        page: 1,
                    });
                }}
            >
                <Form className={styles.searchProducts}>
                    <div className={styles.alignInput}>
                        <Field
                            name="id"
                            type="text"
                            placeholder="Pesquisar por ID"
                            className={styles.input}
                            disabled={isLoading}
                        />
                        <ErrorMessage
                            name="id"
                            component="div"
                            className={styles.error}
                        />

                        <Field
                            name="name"
                            type="text"
                            placeholder="Pesquisar por nome"
                            className={styles.input}
                            disabled={isLoading}
                        />
                        <ErrorMessage
                            name="name"
                            component="div"
                            className={styles.error}
                        />
                    </div>
                    <div className={styles.alignButtonSearch}>
                        <Button
                            type="submit"
                            width="115px"
                            height="39px"
                            theme="primary"
                            fontSize="14px"
                            disabled={isLoading}
                        >
                            Pesquisar
                        </Button>
                    </div>
                </Form>
            </Formik>

            <div className={styles.alignButtonCsvRegister}>
                <Button
                    width="115px"
                    height="39px"
                    theme="close"
                    icon={<Download/>}
                    fontSize="14px"
                    onClick={() => handleDownloadCSV()}
                    disabled={isLoading}
                >
                    CSV
                </Button>
                <Button
                    width="115px"
                    height="39px"
                    theme="primary"
                    fontSize="14px"
                    onClick={() => navigate("/category/create")}
                    disabled={isLoading}
                >
                    Cadastrar
                </Button>
            </div>
            <div className={styles.dNone}>
                <a
                    id="download_csv"
                    rel="noopener noreferrer"
                    href={
                        process.env.REACT_APP_API_URL +
                        "/admin/category/export?" +
                        serializeArray(filter) +
                        "&token=" +
                        getToken()
                    }
                    target="_blank"
                    download
                ></a>
            </div>

            <div className={styles.tableProducts}>
                {isLoading ? (
                    <div className={styles.alignCenter}>
                        <span>Carregando</span>
                        <BarLoader
                            color={"#2b6cded9"}
                            loading={isLoading}
                            aria-label="Loading Spinner"
                            data-testid="loader"
                        />
                    </div>
                ) : (
                    <>
                        {data && data.data.categories.length > 0 ? (
                            <table>
                                <thead>
                                <tr>
                                    <th>Nome</th>
                                    <th>Produtos</th>
                                    <th>Dt Criação</th>
                                    <th></th>
                                    <th></th>
                                </tr>
                                </thead>
                                <tbody>
                                {data.data.categories.map(
                                    (category) => (
                                        <tr key={category.id}>
                                            <td>{category.name}</td>
                                            <td>{category.products}</td>
                                            <td>{category.created_at}</td>
                                            <td>
                                                <button
                                                    className={
                                                        styles.editProducts
                                                    }
                                                    onClick={() =>
                                                        navigate(
                                                            `/category/create/${category.id}`
                                                        )
                                                    }
                                                >
                                                    <Pencil/>
                                                </button>
                                            </td>
                                            <td>
                                                <button
                                                    onClick={() => {
                                                        setId(
                                                            category.id
                                                        );
                                                        setOpen(true);
                                                    }}
                                                    className={
                                                        styles.editProducts
                                                    }
                                                >
                                                    <Trash/>
                                                </button>
                                            </td>
                                        </tr>
                                    )
                                )}
                                </tbody>
                            </table>
                        ) : (
                            <div className={styles.alignCenter}>
                                <span>Nenhum registro encontrado.</span>
                            </div>
                        )}
                    </>
                )}
            </div>
            {data && (
                <Pagination
                    currentPage={data.data.currentPage}
                    lastPage={data.data.lastPage}
                    onPageChange={(payload: number) =>
                        setFilter({...filter, page: payload})
                    }
                />
            )}

            {open && id && (
                <ModalConfirm
                    propsFunction={mutateDeleteCategory.mutate}
                    open={open}
                    setOpen={setOpen}
                    loading={mutateDeleteCategory.isLoading}
                >
                    <span>Essa ação é irreversível!</span>
                    <span>Tem certeza que deseja deletar a categoria?</span>
                </ModalConfirm>
            )}
        </div>
    );
};

export default Categories;
